export { default } from './MaoNaRoda25Comparativo';
